(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var TRANSITION_MS = 500;

  function initSlider(slider) {
    if (slider.dataset.initialized === 'true') return;

    var track = slider.querySelector('[data-announcement-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length <= 1) return;

    slider.dataset.initialized = 'true';

    var intervalMs = (parseFloat(slider.getAttribute('data-autoplay')) || 3) * 1000;
    var mq = window.matchMedia(MOBILE_QUERY);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    var timer = null;
    var index = 0;
    var clone = null;

    function move(i, animate) {
      track.style.transition = animate ? 'transform ' + TRANSITION_MS + 'ms ease' : 'none';
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
    }

    function next() {
      index += 1;
      move(index, true);
    }

    function onTransitionEnd() {
      // Reached the cloned first slide — snap back to the real first slide.
      if (index >= slides.length) {
        index = 0;
        move(0, false);
      }
    }

    function start() {
      stop();
      if (reduce.matches) return;
      timer = window.setInterval(next, intervalMs);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function enable() {
      if (!clone) {
        clone = slides[0].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      index = 0;
      move(0, false);
      track.addEventListener('transitionend', onTransitionEnd);
      start();
    }

    function disable() {
      stop();
      track.removeEventListener('transitionend', onTransitionEnd);
      if (clone && clone.parentNode) {
        clone.parentNode.removeChild(clone);
      }
      clone = null;
      index = 0;
      track.style.transition = 'none';
      track.style.transform = 'none';
    }

    function apply() {
      if (mq.matches) {
        enable();
      } else {
        disable();
      }
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else if (mq.matches) {
        start();
      }
    });

    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
    } else if (mq.addListener) {
      mq.addListener(apply);
    }

    apply();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sliders = scope.querySelectorAll('[data-announcement-slider]');
    Array.prototype.forEach.call(sliders, initSlider);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  // Re-init when the section is added/updated in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
